import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { getZeroStakeValue } from '@/libraries/helpers/stakeInputHelper';
import { useAccountStore } from '@/stores/accountStore';

export const EMPTY_STAKE = 0;

interface StakeLimits {
    minBet: Ref<number>;
    maxBet: Ref<number>;
}

export function useStakeInput(stake: Ref<number>, limits?: StakeLimits) {
    const { customerInfo, displayCurrency, moneySeparators } = storeToRefs(useAccountStore());
    const { formatMoney } = useAccountStore();

    const zeroStakeValue = computed(() => getZeroStakeValue(
        customerInfo.value.currency,
        moneySeparators.value.thousandSeparator,
    ));

    const hasStake = computed(() => stake.value !== EMPTY_STAKE);
    const stakeValue = computed(() => (hasStake.value ? formatMoney(stake.value) : ''));
    const stakeValueWithZero = computed(() => stakeValue.value || zeroStakeValue.value);
    const placeholder = computed(() => (limits
        ? `${formatMoney(limits.minBet.value)} - ${formatMoney(limits.maxBet.value)}`
        : ''));

    return {
        currency: displayCurrency,
        hasStake,
        stakeValue,
        stakeValueWithZero,
        placeholder,
    };
}
